<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Author</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field v-model="Search" label="Search" required id="Search"></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew" > New Author </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="selectedObj.firstName"
              label="First Name*"
              required
              id="firstName"
            ></v-text-field>
          </div>
          <div class="col">
                 <v-text-field
              v-model="selectedObj.lastName"
              label="Last Name*"
              required
              id="lastName"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="float-right action-area">
              <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
              <v-btn class="mr-4" color="primary" @click="onSave()" id="btnPrimary">
                Save
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Author Name</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in resultQuery" :key="item.id" :id="'svg' + item.id">
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import * as api from "@/api";
export default {
  name: "Author",
  components: {
    Notification,
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every((v) => item.title.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    },
  },
  created() {
    this.getAuthor();
  },
  methods: {
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.firstName = "";
      this.selectedObj.lastName = "";
    },
    onSave() {
      new Promise((resolve, reject) => {
        api
          .update("author", this.selectedObj)
          .then((response) => {
            resolve(response);
            console.log(response.status);
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
                this.getAuthor();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            reject(error);
          });
      });
      this.isEdit = false;
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj = Object.assign({}, obj);
    },
    onDelete(obj) {
      if (confirm("Do you really want to delete this record?")) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("author", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getAuthor();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
    },
    getAuthor() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("author")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  data() {
    return {
      id: 0,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {},
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
    };
  },
};
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Author.vue